import { Indicator } from '../../../Common/Charts/Indicator';
import { useParentsInfoChartsDataContext } from './hooks/useParentsInfoChartsDataContext';

export const TenagerMothers = () => {
    const { chartData } = useParentsInfoChartsDataContext();

    return (
        <Indicator
            title={'Mães Adolescentes (menor de 18 anos)'}
            indicatorValue={chartData?.indicators?.tenagerMothers}
        />
    );
};
